import AsyncStorage from "@react-native-async-storage/async-storage";
import {Alert, Platform} from "react-native";
import axios from 'axios';
import {sendPrinterAndroid, showPrintErrorDialog} from "./printerLibrary/printer";
import {getBigReceiptData, getBigTerminalData} from "./printerLibrary/oldPrinter";
import {getUserInfo} from "./storage";

const API_URL = "https://api.happygastro.hu/api";
const generateRandomNumberString = (length = 10) => {
    let result = '';
    const characters = '0123456789';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
};

const fetchBarcodeAsBase64 = async (value) => {
    const url = `${API_URL}/tickets/barcode/${value}`;

    try {
        const response = await axios.get(url, {responseType: 'json'});
        return response.data.barcode || response.barcode;
    } catch (error) {
        console.error('Error fetching barcode:', error);
    }
};

export function RawBTPrintKitchen(order, items) {
    try {
        // Import the background task trigger function
        const { triggerKitchenPrinting } = require('./BackgroundTasks');

        console.log("Order Items", items);

        // Use the background task to print to kitchen printers
        triggerKitchenPrinting(order, items)
            .catch(async error => {
                console.error('Error triggering kitchen printing:', error);

                // Get the actual printer information from AsyncStorage
                const storedPrinterEvents = await AsyncStorage.getItem('printerEvents');
                const printerEvents = storedPrinterEvents ? JSON.parse(storedPrinterEvents) : [];

                // Get the first terminal printer if available
                let printer = { ip: '', macAddress: '' }; // Default fallback

                if (printerEvents.length > 0) {
                    const terminalEvents = printerEvents.filter(event => event.type === "terminal");
                    if (terminalEvents.length > 0 && terminalEvents[0].printers && terminalEvents[0].printers.length > 0) {
                        printer = terminalEvents[0].printers[0];
                    }
                }

                // Get restaurant data and user info for the template
                const userInfo = await getUserInfo();
                const restaurantData = await AsyncStorage.getItem("restaurant");

                // Show the custom error dialog with retry option using the actual printer
                showPrintErrorDialog(
                    getBigTerminalData(order, restaurantData ? JSON.parse(restaurantData) : {}, userInfo), 
                    printer, 
                    true, 
                    true
                );
            });
    } catch (e) {
        console.error(e);

        // Handle synchronous errors by getting printer info asynchronously
        AsyncStorage.getItem('printerEvents')
            .then(storedPrinterEvents => {
                const printerEvents = storedPrinterEvents ? JSON.parse(storedPrinterEvents) : [];
                let printer = { ip: '', macAddress: '' }; // Default fallback

                if (printerEvents.length > 0) {
                    const terminalEvents = printerEvents.filter(event => event.type === "terminal");
                    if (terminalEvents.length > 0 && terminalEvents[0].printers && terminalEvents[0].printers.length > 0) {
                        printer = terminalEvents[0].printers[0];
                    }
                }

                // Get data for the template
                Promise.all([
                    getUserInfo(),
                    AsyncStorage.getItem("restaurant")
                ]).then(([userInfo, restaurantData]) => {
                    showPrintErrorDialog(
                        getBigTerminalData(order, restaurantData ? JSON.parse(restaurantData) : {}, userInfo), 
                        printer, 
                        true, 
                        true
                    );
                });
            })
            .catch(asyncError => {
                console.error('Error getting printer info:', asyncError);
                // Fallback to dummy printer if everything fails
                const dummyPrinter = { ip: '', macAddress: '' };
                showPrintErrorDialog(getBigTerminalData(order, {}, {}), dummyPrinter, true, true);
            });
    }
}

export function RawBTPrintTicket(order, items) {
    try {
        // Import the background task trigger function
        const { triggerReceiptPrinting } = require('./BackgroundTasks');

        // Use the background task to print the receipt
        triggerReceiptPrinting(order)
            .catch(async error => {
                console.error('Error triggering receipt printing:', error);

                // Try to get the main printer device first
                const printerDevice = await AsyncStorage.getItem('printerDevice');
                let printer = printerDevice ? JSON.parse(printerDevice) : null;

                // If no main printer, try to get from printer events
                if (!printer) {
                    const storedPrinterEvents = await AsyncStorage.getItem('printerEvents');
                    const printerEvents = storedPrinterEvents ? JSON.parse(storedPrinterEvents) : [];

                    if (printerEvents.length > 0) {
                        const receiptEvent = printerEvents.find(event => event.type === "receipt");
                        if (receiptEvent && receiptEvent.printers && receiptEvent.printers.length > 0) {
                            printer = receiptEvent.printers[0];
                        }
                    }
                }

                // If still no printer, use default empty values
                if (!printer) {
                    printer = { ip: '', macAddress: '' };
                }

                // Get data for the template
                const userInfo = await getUserInfo();
                const restaurantData = await AsyncStorage.getItem("restaurant");
                const restaurantPlaceData = await AsyncStorage.getItem("restaurantPlace");

                // Show the custom error dialog with retry option using the actual printer
                showPrintErrorDialog(
                    getBigReceiptData(
                        order, 
                        restaurantData ? JSON.parse(restaurantData) : {}, 
                        restaurantPlaceData ? JSON.parse(restaurantPlaceData) : {}, 
                        userInfo
                    ), 
                    printer, 
                    true, 
                    true
                );
            });
    } catch (e) {
        console.error(e);

        // Handle synchronous errors by getting printer info asynchronously
        Promise.all([
            AsyncStorage.getItem('printerDevice'),
            AsyncStorage.getItem('printerEvents'),
            getUserInfo(),
            AsyncStorage.getItem("restaurant"),
            AsyncStorage.getItem("restaurantPlace")
        ])
        .then(([printerDevice, storedPrinterEvents, userInfo, restaurantData, restaurantPlaceData]) => {
            // Try to get the main printer device first
            let printer = printerDevice ? JSON.parse(printerDevice) : null;

            // If no main printer, try to get from printer events
            if (!printer) {
                const printerEvents = storedPrinterEvents ? JSON.parse(storedPrinterEvents) : [];

                if (printerEvents.length > 0) {
                    const receiptEvent = printerEvents.find(event => event.type === "receipt");
                    if (receiptEvent && receiptEvent.printers && receiptEvent.printers.length > 0) {
                        printer = receiptEvent.printers[0];
                    }
                }
            }

            // If still no printer, use default empty values
            if (!printer) {
                printer = { ip: '', macAddress: '' };
            }

            // Show the custom error dialog with retry option using the actual printer
            showPrintErrorDialog(
                getBigReceiptData(
                    order, 
                    restaurantData ? JSON.parse(restaurantData) : {}, 
                    restaurantPlaceData ? JSON.parse(restaurantPlaceData) : {}, 
                    userInfo
                ), 
                printer, 
                true, 
                true
            );
        })
        .catch(asyncError => {
            console.error('Error getting printer info:', asyncError);
            // Fallback to dummy printer if everything fails
            const dummyPrinter = { ip: '', macAddress: '' };
            showPrintErrorDialog(getBigReceiptData(order, {}, {}, {}), dummyPrinter, true, true);
        });
    }
}
